









import LabSim from '@/tasks/components/simulations/LabSim.vue';
import {defineComponent, PropType} from '@vue/composition-api';

interface IRedoxTitrationInputs {
  conOfAcid: number;
}

export default defineComponent({
  name: 'LabRedoxTitration',
  components: {LabSim},
  inheritAttrs: false,
  props: {
    concOxalicAcid: {
      type: Number as PropType<number>,
      default: 0.25,
    },
  },
  computed: {
    labData(): IRedoxTitrationInputs {
      return {
        conOfAcid: this.concOxalicAcid,
      };
    },
    stringifiedLabData(): string {
      return JSON.stringify(this.labData);
    },
  },
});
